import { Link } from "@tanstack/react-router"
import { Helmet } from "react-helmet-async"

export function AuthFrame({ children, title }: { children: React.ReactNode; title: string }) {
  return (
    <main className="auth-page">
      <Helmet>
        <title>{title} · TutorLite</title>
      </Helmet>
      <div className="mascot mascot-blue" aria-hidden="true">
        ✦
      </div>
      <section className="auth-card">
        <Link className="wordmark" to="/">
          TutorLite<span>.</span>
        </Link>
        <h1>{title}</h1>
        {children}
      </section>
      <div className="mascot mascot-yellow" aria-hidden="true">
        ●
      </div>
    </main>
  )
}
